import { Action, createReducer, on } from '@ngrx/store';
import { consultPatientActions } from './consult-patient.action';
import { consultPatientIS, ConsultPatientState } from './consult-patient.state';

const consultPatientRegister = createReducer(consultPatientIS,
  on(consultPatientActions.setTurnTypeAction, (state, { turnType }) => ({
    ...state,
    turnType
  })),

  on(consultPatientActions.setHistoryPdfAction, (state, { file: historyPdf }) => ({
    ...state,
    historyPdf
  })),

  on(consultPatientActions.setAllDefaultAction, () => consultPatientIS)
);

export function consultPatientReducer(state: ConsultPatientState, action: Action): any {
  return consultPatientRegister(state, action);
}
